import packageJson from '../../package.json';

/**
 * What version of the app this is, worked out at build time so nobody has to
 * remember to bump anything.
 *
 * `package.json`'s `version` is typed by hand and in practice never moves —
 * it sat at 1.7.4 across every deploy of the sync-hardening work — so it could
 * not answer the only question anyone actually asks it: is this phone running
 * a current copy? A calendar version can, at a glance: `2026.07.02` next to
 * `2026.08.08` is obviously five weeks stale, whereas two commit hashes tell
 * you nothing about which came first.
 *
 * Both values come from the build script (see package.json). On a dev server
 * neither is set, so this falls back to package.json's version rather than
 * rendering something empty or misleading.
 */
export const APP_VERSION: string =
  process.env.REACT_APP_BUILD_VERSION || packageJson.version;

/** The exact commit this bundle was built from. Empty on a dev server. */
export const BUILD_ID: string = process.env.REACT_APP_BUILD_ID || '';

/**
 * The version as shown to a person: `v2026.08.08 (50a38ab)`.
 *
 * The date says how current it is; the build id says exactly which build, so a
 * report of "it's doing X" can be tied to a specific commit. Without a build
 * id (dev server) the brackets are omitted rather than left empty.
 */
export function versionLabel(): string {
  return BUILD_ID ? `v${APP_VERSION} (${BUILD_ID})` : `v${APP_VERSION}`;
}

/**
 * Version fragment for filenames — no spaces, no brackets, sorts correctly in
 * a file listing, which is exactly what you want when a folder holds several
 * months of backups.
 */
export function versionForFilename(): string {
  return BUILD_ID ? `${APP_VERSION}-${BUILD_ID}` : APP_VERSION;
}
